export default __webpack_public_path__ + "static/media/feature2.8c26ed1c.svg";